import Link from "next/link";

import clsx from "clsx";

import { ClickServer } from "shared-lib/clickserver";
import * as gtag from "shared-lib/gtag";
import {
  TRACKING_EVENTS,
  logStatsig,
  TRACKING_CATEGORIES,
} from "shared-lib/helpers/statsigFunctions";

import SymbolizedElement from "shared-components/components/SymbolizedElement";

import RecipeImage from "@/components/recipe/image";
import { getRecipeLink } from "@/lib/helpers/frontendFunctions";

export default function RecipeGridItemRedesign({
  recipe = {} as Recipe,
  index = 0,
  className = "",
  priority = false,
  big = false,
  onClick = () => {
    return;
  },
  exploreMore = false,
}: {
  recipe: Recipe;
  index?: number;
  className?: string;
  priority?: boolean;
  big?: boolean;
  onClick?: () => void;
  exploreMore?: boolean;
}) {
  return (
    <Link
      href={getRecipeLink(recipe)}
      id={recipe.sys.id}
      onClick={() => {
        onClick();

        if (exploreMore) {
          gtag.event({
            action: TRACKING_EVENTS.explore_more_tile_click,
            category: TRACKING_CATEGORIES.navigation,
            label: index.toString(),
          });

          logStatsig(TRACKING_EVENTS.explore_more_tile_click, {
            index: index.toString(),
            tile_type: "recipe",
          });
          ClickServer.track(TRACKING_EVENTS.explore_more_tile_click, {
            index: index.toString(),
            tile_type: "recipe",
          });
        } else {
          gtag.event({
            action: TRACKING_EVENTS.recipe_tile_click,
            category: TRACKING_CATEGORIES.navigation,
            label: index.toString(),
          });

          logStatsig(TRACKING_EVENTS.recipe_tile_click, {
            index: index.toString(),
          });
          ClickServer.track(TRACKING_EVENTS.recipe_tile_click, {
            index: index.toString(),
          });
        }
      }}
      className={clsx(
        className,
        "bg-redesign-gray/80 !block overflow-hidden rounded-b-2xl rounded-t-xl",
      )}
    >
      <>
        <RecipeImage
          priority={priority}
          recipe={recipe}
          size={big ? "large" : "medium"}
          className={clsx(big ? "flex-grow-1 h-[87.7%]" : "h-60", "rounded-xl")}
        />

        <div className="w-full p-4">
          <div
            className={clsx(
              "mb-1 line-clamp-1 w-full font-bold leading-normal text-theme-primary-dark transition-colors duration-300 group-hover:text-blue-500",
              big ? "text-xl sm:text-3xl" : "text-md sm:text-xl",
            )}
          >
            <SymbolizedElement title={recipe.title} />
          </div>
          <div
            className={clsx(
              "mb-4 w-full text-base text-theme-gray-300 transition-colors duration-300 group-hover:text-blue-500",
              big ? "line-clamp-1" : "line-clamp-2",
            )}
          >
            {recipe.richDescription?.json?.content &&
              recipe.richDescription.json.content.length > 0 &&
              recipe.richDescription.json.content[0].content.length > 0 &&
              recipe.richDescription.json.content[0].content[0].value}
          </div>
        </div>
      </>
    </Link>
  );
}
